import { render, staticRenderFns } from "./returnsOut_New.vue?vue&type=template&id=ad33d336&scoped=true&"
import script from "./returnsOut_New.vue?vue&type=script&lang=js&"
export * from "./returnsOut_New.vue?vue&type=script&lang=js&"
import style0 from "./returnsOut_New.vue?vue&type=style&index=0&lang=less&"
import style1 from "./returnsOut_New.vue?vue&type=style&index=1&id=ad33d336&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad33d336",
  null
  
)

component.options.__file = "returnsOut_New.vue"
export default component.exports